import { h } from 'preact'; /** @jsx h */

import './Image.scss';

const Image = ({ src, alt, caption, captionColor = '', className }) => {
    return (
        <div
            className={`article-inline-image ${
                captionColor && `color-${captionColor}`
            } ${className}`}
        >
            <figure>
                <img src={src} alt={alt} loading="lazy" />
                <figcaption>{caption}</figcaption>
            </figure>
        </div>
    );
};

export default Image;
